export default {"src":"/_next/static/media/squiggly-arrow-decoration.f6de949a.svg","height":108,"width":106,"blurWidth":0,"blurHeight":0};